/* Подсказка в корзине: при одной маске предлагаем вторую за −$30. Товары — из #atUpsell (snippets/at-extras.liquid). */
(function(){
  var dataEl = document.getElementById('atUpsell');
  if (!dataEl) return;
  var list = [];
  try { list = JSON.parse(dataEl.textContent); } catch (err) {}

  var drawer = document.getElementById('cartDr');
  var box = document.getElementById('cartItems');
  var upd = document.querySelector('.cartform .cartupd');
  var page = null;
  if (upd) {
    page = document.createElement('div');
    page.id = 'cartUpsellPage';
    upd.parentNode.insertBefore(page, upd.nextSibling);
  }

  function esc(s){
    return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; });
  }

  function html(cart){
    var masks = 0, inCart = {};
    cart.items.forEach(function(it){
      if (String(it.product_type).indexOf('Mask') > -1) masks += it.quantity;
      inCart[it.product_id] = true;
    });
    if (masks !== 1) return '';
    /* на странице корзины после добавления её надо перезагрузить; в выезжающей корзине работает обычный .qadd */
    var cls = page ? 'upadd upbtn' : 'qadd upbtn';
    var rows = list.filter(function(m){ return !inCart[m.p]; }).slice(0, 6).map(function(m){
      return '<div class="upc"><a href="'+esc(m.u)+'"><img src="'+esc(m.i)+'" alt="" loading="lazy"></a>'+
        '<div class="n">'+esc(m.t)+'</div><div class="m">'+esc(m.m)+'</div>'+
        '<button type="button" class="'+cls+'" data-add="'+m.v+'">+ Add</button></div>';
    }).join('');
    return '<div class="upsell"><div class="uph">Add one more mask, save <em>$30</em></div>'+
      '<div class="ups">The discount applies automatically.</div>'+
      (rows ? '<div class="uprow">'+rows+'</div>' : '<a class="upall" href="/collections/mask">Shop masks</a>')+'</div>';
  }

  var token = 0;
  function draw(){
    var t = ++token;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      if (t !== token) return;
      var h = html(cart);
      if (page) page.innerHTML = h;
      if (box) {
        var old = box.querySelector('.upsell');
        if (old) old.remove();
        if (h) box.insertAdjacentHTML('beforeend', h);
      }
    });
  }

  /* корзина перерисовывается в alexterrible.js (renderCart): дорисовываем подсказку после этого */
  if (box) new MutationObserver(function(ms){
    var own = ms.every(function(m){
      return [].every.call(m.addedNodes, function(n){ return n.classList && n.classList.contains('upsell'); });
    });
    if (!own) draw();
  }).observe(box, {childList:true});

  /* пока корзина открыта, прячем чат-бота: он закрывает Checkout. У него свой display с !important, поэтому меняем именно его */
  if (drawer) new MutationObserver(function(){
    var bot = document.getElementById('zipchat-shadow-host');
    if (bot) bot.style.setProperty('display', drawer.classList.contains('open') ? 'none' : 'contents', 'important');
  }).observe(drawer, {attributes:true, attributeFilter:['class']});

  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.upadd');
    if (!b) return;
    b.disabled = true;
    b.textContent = 'Adding…';
    fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: +b.getAttribute('data-add'), quantity: 1})})
      .then(function(){ location.reload(); });
  });

  if (page) draw();

  /* человечек на плашке: идёт до середины, поворачивается к покупателю, тычет в него, потом на FINANCING, идёт до края, разворачивается и делает то же самое обратно */
  function runMan(man, plate){
    if (!man || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var SPEED = 42, x = 0, dir = 1;
    function wait(ms){ return new Promise(function(done){ setTimeout(done, ms); }); }
    function pose(name){ man.className = 'atman' + (name ? ' ' + name : ''); }
    function walkTo(target){
      var ms = Math.abs(target - x) / SPEED * 1000;
      x = target;
      pose('walk');
      man.style.transition = 'transform ' + ms + 'ms linear';
      man.style.transform = 'translateX(' + x + 'px)';
      return wait(ms);
    }
    function point(){
      pose('front');
      return wait(350)
        .then(function(){ pose('front you'); return wait(1400); })
        .then(function(){ pose('front'); return wait(200); })
        .then(function(){ pose('front fin'); return wait(1400); })
        .then(function(){ pose('front'); return wait(250); });
    }
    function turn(){
      pose('');
      return wait(250).then(function(){
        dir = -dir;
        man.setAttribute('data-dir', dir);
        return wait(250);
      });
    }
    function lap(){
      var far = plate.clientWidth - man.offsetWidth;
      return walkTo(far / 2).then(point).then(function(){
        return walkTo(dir > 0 ? far : 0);
      }).then(turn).then(lap);
    }
    lap();
  }

  /* плашка FINANCING: включаем, только когда Shopify реально вывел текст рассрочки; на медленном интернете ждём до минуты */
  var fin = document.querySelector('.atfin');
  if (fin) {
    var finTries = 0, finTimer = setInterval(function(){
      var terms = fin.querySelector('shopify-payment-terms');
      if (terms && terms.shadowRoot && terms.shadowRoot.textContent.trim()) {
        fin.classList.add('on');
        clearInterval(finTimer);
        runMan(fin.querySelector('.atman'), fin);
      } else if (++finTries > 240) clearInterval(finTimer);
    }, 250);
  }

  /* на телефоне приветствие бота закрывает кнопку покупки: на товаре и в корзине его не показываем, значок чата остаётся */
  if (window.innerWidth <= 900 && (document.getElementById('atForm') || page)) {
    var botTries = 0, botTimer = setInterval(function(){
      var bot = document.getElementById('zipchat-shadow-host');
      var root = bot && bot.shadowRoot;
      if (root) {
        var st = document.createElement('style');
        st.textContent = '#chat-preview-message{display:none !important}';
        root.appendChild(st);
        clearInterval(botTimer);
      } else if (++botTries > 30) clearInterval(botTimer);
    }, 500);
  }
})();
